import Cliente from "./Cliente";
export default Cliente;